<template>
  <div
      v-loading="loading"
      class="order-return-review-customer-details flex flex-auto flex-col">
    <div class="title">
      Review customer details and address
    </div>
    <div class="description">
      Review the customer details before submitting a request.
    </div>
    <div style="margin-top: 24px">
      <div class="section-header">
        <div class="flex-1">
          Replacement Summary
        </div>
      </div>
    </div>
    <div class="return-customer-details">
      <el-card shadow="never">
        <div class="flex flex-col">
          <div
              class="summary-header">
            Old Product
          </div>
          <div style="margin-top: 8px;">
            {{ device.profile.product.description }}<br>
            <p style="color: #6E6E6E; margin: 0 !important;">
              MAC ID: {{ device.mac_address }}
            </p>
            <p
                v-if="device.profile && device.profile.color"
                style="color: #6E6E6E; margin: 0 !important;">
              {{ device.profile.color }}
            </p>
          </div>
        </div>
        <el-divider />
        <div class="flex flex-col">
          <div
              class="summary-header">
            Replacement Product
          </div>
          <div style="margin-top: 8px;">
            {{ replacementProduct.product.description }}<br>
            <p style="color: #6E6E6E; margin: 0 !important;">
              {{ replacementProduct.color }}
            </p>
            <p
                v-if="replacementProduct.estimated_delivery"
                class="estimated-delivery"
                style="margin: 0 !important;">
              {{ replacementProduct.estimated_delivery }}
            </p>
          </div>
          <div
              v-if="replacementProduct.out_of_stock"
              class="flex flex-col">
            <el-alert
                title="This product is out of stock."
                type="error"
                show-icon>
              <span>Estimated back stock date is
                <time-zone-formatter :current-time="replacementProduct.restock_dt" />.
              </span>
            </el-alert>
            <el-alert
                type="warning"
                description="Ring Neighbors will be sent an equal or better device depending on stock availability of the device requested."
                show-icon />
          </div>
        </div>
        <el-divider />
        <div class="flex flex-col">
          <div
              class="summary-header">
            Replacement Reason
          </div>
          <div style="margin-top: 8px;">
            {{ selectedName }}<br>
          </div>
        </div>
        <el-divider />
        <div class="flex flex-col">
          <div
              class="summary-header">
            Other Info
          </div>
          <div
              class="flex flex-row"
              style="margin-top: 8px;">
            <div class="flex-1">
              Place of purchase
            </div>
            <div>{{ retailer }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Date of initial setup
            </div>
            <div>
              <time-zone-formatter
                  output-format="DD MMMM, YYYY"
                  :current-time="firstSetupDate" />
            </div>
          </div>
        </div>
        <el-divider />
        <div class="flex flex-col">
          <div
              class="summary-header">
            Customer info
          </div><br>
        </div>
        <div class="flex flex-col">
          <div class="flex flex-row">
            <div class="flex-1">
              Name
            </div>
            <div>{{ customer.first_name }} {{ customer.last_name }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Phone Number
            </div>
            <div>{{ customer.phone_number }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Email
            </div>
            <div>{{ customer.email }}</div>
          </div>
          <div
              class="flex flex-row"
              style="margin-top: 20px">
            <div class="flex-1">
              Street
            </div>
            <div>{{ address.address1 }} {{ address.address2 }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              City
            </div>
            <div>{{ address.city }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              State/province/area
            </div>
            <div>{{ address.state }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Zip code
            </div>
            <div>{{ address.zip_code }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Country
            </div>
            <div>{{ address.country }}</div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import numeral from "numeral";
import axios from "axios";

export default {
  name: "ReviewReplacementSummary",
  props: {
    firstSetupDate: {
      type: String,
      default: "",
    },
    device: {
      type: Object,
      required: true,
    },
    replacementProduct: {
      type: Object,
      required: true,
    },
    selectedName: {
      type: String,
      default: "",
    },
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          first_name: "",
          last_name: "",
          phone_number: "",
          email: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip_code: "",
          country: "",
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      retailer: "",
    };
  },
  mounted() {
    this.loading = false;
    if (this.device.profile.retailer) {
      this.retailer = this.device.profile.retailer.name;
    } else this.retailer = "N/A";
  },
  methods: {},
};
</script>

<style>
.order-return-review-customer-details {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .return-customer-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #424242;
  }

  .estimated-delivery {
    color: var(--light-content-backup, #6e6e6e);
    font-family: Equip;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .edit-details-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    text-decoration-line: underline;
    color: #1476ad;
  }
}

.summary-header {
  width: 939px;
  height: 24px;

  /* body/large-medium */

  font-family: "Equip";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: flex-end;

  /* 🖥 light/content/base */

  color: #424242;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}
</style>
